  <template>
  <div
    :class="{ 'has-mouse': hasMouse }"
    @touchstart="hasMouse = false"
  >
    <div v-if="!isAuthenticated" class="login-wrapper" :style="{ backgroundImage: 'url(/bg.png)' }">
      <div class="login-card">
        <h1 class="login-title">Digital HR Handbook</h1>
        <form @submit.prevent="handleLogin" class="login-form">
          <div class="input-group">
            <label for="username">Username</label>
            <input
              type="text"
              id="username"
              v-model="username"
              placeholder="Enter Username"
              required
            />
          </div>
          <div class="input-group">
            <label for="password">Password</label>
            <input
              type="password"
              id="password"
              v-model="password"
              placeholder="Enter Password"
              required
            />
          </div>
          <div v-if="loginError" class="error-msg">
            Invalid username or password.
          </div>
          <button type="submit" class="login-btn">Login</button>
        </form>
        <div class="logo-container">
          <img src="/hayat-logo.png" alt="Hayat Global Logo" class="app-logo" />
          <img src="/make-your-move-logo.png" alt="Make Your Move Logo" class="app-logo" />
        </div>
      </div>
    </div>

    <template v-else>
      <Flipbook
        class="flipbook show-desktop"
        :pages="pagesDesktop"
        :startPage="pageNum"
        :singlePage="false"
        v-slot="flipbook"
        ref="flipbookDesktop"
        @flip-left-start="onFlipLeftStart"
        @flip-left-end="onFlipLeftEnd"
        @flip-right-start="onFlipRightStart"
        @flip-right-end="onFlipRightEnd"
        @zoom-start="onZoomStart"
        @zoom-end="onZoomEnd"
      >
        <div class="action-bar">
          <left-icon
            class="btn left"
            :class="{ disabled: !flipbook.canFlipLeft }"
            @click="flipbook.flipLeft"
          />
          <plus-icon
            class="btn plus"
            :class="{ disabled: !flipbook.canZoomIn }"
            @click="flipbook.zoomIn"
          />
          <span class="page-num">
            <input
              type="number"
              class="page-input"
              :value="flipbook.page"
              @keydown.enter="$event.target.blur()"
              @change="onPageInputChange($event, flipbook.numPages)"
              min="1"
              :max="flipbook.numPages"
            />
            / {{ flipbook.numPages }}
          </span>
          <minus-icon
            class="btn minus"
            :class="{ disabled: !flipbook.canZoomOut }"
            @click="flipbook.zoomOut"
          />
          <right-icon
            class="btn right"
            :class="{ disabled: !flipbook.canFlipRight }"
            @click="flipbook.flipRight"
          />
          <button @click="handleLogout" class="logout-btn-mini">Çıkış Yap</button>
        </div>
      </Flipbook>

      <Flipbook
        class="flipbook show-mobile"
        :pages="pagesMobile"
        :startPage="pageNum"
        :singlePage="true"
        v-slot="flipbook"
        ref="flipbookMobile"
        @flip-left-start="onFlipLeftStart"
        @flip-left-end="onFlipLeftEnd"
        @flip-right-start="onFlipRightStart"
        @flip-right-end="onFlipRightEnd"
        @zoom-start="onZoomStart"
        @zoom-end="onZoomEnd"
      >
        <div class="action-bar">
          <left-icon
            class="btn left"
            :class="{ disabled: !flipbook.canFlipLeft }"
            @click="flipbook.flipLeft"
          />
          <plus-icon
            class="btn plus"
            :class="{ disabled: !flipbook.canZoomIn }"
            @click="flipbook.zoomIn"
          />
          <span class="page-num">
            <input
              type="number"
              class="page-input"
              :value="flipbook.page"
              @keydown.enter="$event.target.blur()"
              @change="onPageInputChange($event, flipbook.numPages)"
              min="1"
              :max="flipbook.numPages"
            />
            / {{ flipbook.numPages }}
          </span>
          <minus-icon
            class="btn minus"
            :class="{ disabled: !flipbook.canZoomOut }"
            @click="flipbook.zoomOut"
          />
          <right-icon
            class="btn right"
            :class="{ disabled: !flipbook.canFlipRight }"
            @click="flipbook.flipRight"
          />
          <button @click="handleLogout" class="logout-btn-mini">Çıkış Yap</button>
        </div>
      </Flipbook>
    </template>
  </div>
</template>

<script>
import "vue-material-design-icons/styles.css";
import SetupSchema from "../setup.json";
import LeftIcon from "vue-material-design-icons/ChevronLeftCircle";
import RightIcon from "vue-material-design-icons/ChevronRightCircle";
import PlusIcon from "vue-material-design-icons/PlusCircle";
import MinusIcon from "vue-material-design-icons/MinusCircle";
import Flipbook from "flipbook-vue";

export default {
  components: { Flipbook, LeftIcon, RightIcon, PlusIcon, MinusIcon },
  data() {
    return {
      pagesDesktop: [],
      pagesMobile: [],

      hasMouse: true,
      pageNum: null,

      isAuthenticated: false,
      username: "",
      password: "",
      loginError: false,
    };
  },
  watch: {
    pageNum(n) {
      if (n === null) return;
      let page = parseInt(n, 10);
      if (isFinite(page)) {
        // Round odd numbers > 1 down to the nearest even number
        if (page > 1 && page % 2 !== 0) page -= 1;

        if (this.$refs.flipbookDesktop) this.$refs.flipbookDesktop.goToPage(page);
        if (this.$refs.flipbookMobile) this.$refs.flipbookMobile.goToPage(page);
        window.location.hash = page;
      }
    },
  },
  methods: {
    setPageFromHash() {
      const n = parseInt(window.location.hash.slice(1), 10);
      if (isFinite(n)) this.pageNum = n;
    },
    onPageInputChange(event, max) {
      let n = parseInt(event.target.value, 10);
      if (isNaN(n)) {
        event.target.value = this.pageNum;
        return;
      }
      if (n < 1) n = 1;
      if (n > max) n = max;

      // Round odd numbers > 1 down to the nearest even number
      if (n > 1 && n % 2 !== 0) n -= 1;

      this.pageNum = n;
    },
    handleLogin() {
      // Simple authentication check - can be enhanced later
      if (this.username === "GlobalHR" && this.password === "2026*") {
        this.isAuthenticated = true;
        this.loginError = false;
        localStorage.setItem("magazine_auth", "true");
      } else {
        this.loginError = true;
      }
    },
    handleLogout() {
      this.isAuthenticated = false;
      this.username = "";
      this.password = "";
      localStorage.removeItem("magazine_auth");
      window.location.hash = "";
    },
  },
  mounted() {
    window.addEventListener("keydown", (ev) => {
      const flipbook =
        this.$refs.flipbookDesktop?.clientHeight > 0
          ? this.$refs.flipbookDesktop
          : this.$refs.flipbookMobile;
      if (!flipbook) return;
      if (ev.keyCode == 37 && flipbook.canFlipLeft) flipbook.flipLeft();
      if (ev.keyCode == 39 && flipbook.canFlipRight) flipbook.flipRight();
    });

    const getSlides = (count, folder, name, ext) => {
      const slides = [];

      for (let i = 1; i <= count; i++) {
        slides.push(`images/${folder}/${name}${i}.${ext}`);
      }

      return slides;
    };

    const { desktopImages, mobileImages } = SetupSchema;

    setTimeout(() => {
      this.pagesDesktop = [
        null,
        ...getSlides(
          desktopImages.count,
          desktopImages.folder,
          desktopImages.slug,
          desktopImages.ext
        ),
      ];
      this.pagesMobile = [
        null,
        ...getSlides(
          mobileImages.count,
          mobileImages.folder,
          mobileImages.slug,
          mobileImages.ext
        ),
      ];
    }, 1);

    window.addEventListener("hashchange", this.setPageFromHash);
    this.setPageFromHash();

    // Check for existing session
    if (localStorage.getItem("magazine_auth") === "true") {
      this.isAuthenticated = true;
    }
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
}

#app {
  font-family: "Outfit", "Inter", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #1a1a1a;
  color: #eee;
  overflow: hidden;
}

/* Login Styles */
.login-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

.login-wrapper::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1;
}

.login-card {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 400px;
  padding: 40px;
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  text-align: center;
}

.logo-container {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
}

.app-logo {
  max-width: 200px;
  height: auto;
}

.login-title {
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 32px;
  color: #1a1a1a;
  letter-spacing: -0.5px;
}

.login-form {
  text-align: left;
}

.input-group {
  margin-bottom: 20px;
}

.input-group label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #444;
}

.input-group input {
  width: 100%;
  padding: 12px 16px;
  background: #f8f9fa;
  border: 1px solid #dfe3e6;
  border-radius: 8px;
  color: #1a1a1a;
  font-size: 16px;
  outline: none;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.input-group input:focus {
  background: #ffffff;
  border-color: #1a1a1a;
  box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.05);
}

.login-btn {
  width: 100%;
  padding: 14px;
  background: #98cc03;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 12px;
}

.login-btn:hover {
  background: #333333;
  transform: translateY(-1px);
}

.login-btn:active {
  transform: translateY(0);
}

.error-msg {
  color: #ff4d4d;
  font-size: 14px;
  margin-bottom: 16px;
  text-align: center;
}

a {
  color: inherit;
}

.action-bar {
  width: 100%;
  height: 30px;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-bar .btn {
  font-size: 30px;
  color: #999;
}

.action-bar .btn svg {
  bottom: 0;
}

.action-bar .btn:not(:first-child) {
  margin-left: 10px;
}

.has-mouse {
  height: 100%;
  width: 100%;
}

.has-mouse .action-bar .btn:hover {
  color: #ccc;
  filter: drop-shadow(1px 1px 5px #000);
  cursor: pointer;
}

.action-bar .btn:active {
  filter: none !important;
}

.action-bar .btn.disabled {
  color: #666;
  pointer-events: none;
}

.action-bar .page-num {
  font-size: 14px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  color: #bbb;
}

.action-bar .page-input {
  width: 45px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid #555;
  color: #fff;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  padding: 4px 2px;
  margin: 0 8px;
  outline: none;
  transition: all 0.2s ease;
}

.action-bar .page-input:focus {
  border-color: #aaa;
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 0 5px rgba(255, 255, 255, 0.2);
}

.action-bar .page-input::-webkit-inner-spin-button,
.action-bar .page-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.action-bar .page-input {
  appearance: textfield;
  -moz-appearance: textfield;
}

.logout-btn-mini {
  margin-left: 20px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #ccc;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.logout-btn-mini:hover {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.flipbook-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flipbook-container div:nth-child(3) {
  width: 100%;
}

.flipbook .viewport {
  width: 90vw !important;
  height: calc(100vh - 50px - 40px) !important;
  margin: 0 auto;
}

.flipbook .bounding-box {
  box-shadow: 0 0 20px #000;
}

.credit {
  font-size: 12px;
  line-height: 20px;
  margin: 10px;
}

@media screen and (max-width: 768px) {
  .show-desktop {
    display: none;
  }

  .show-mobile {
    display: block;
  }
}

@media screen and (min-width: 768px) {
  .show-desktop {
    display: block;
  }

  .show-mobile {
    display: none;
  }
}
</style>
